import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import screenfull from "screenfull";

class Controlos extends Component {
    state = {
        fullscreen: false
    };

    onClickFullscreen = () => {
        this.setState({ fullscreen: !this.state.fullscreen });
        screenfull.toggle();
    };

    handleGoBack = () => {
        this.props.history.goBack();
    };

    render() {
        return (
            <div className="bloco-controlos">
                <div className="controlos">
                    <div className="container-btn">
                        <button onClick={this.handleGoBack} title="Voltar" style={{ width: "100%", height: "100%" }}>
                            <i className="fas fa-chevron-left" />
                        </button>
                    </div>
                    <div className="container-btn">
                        <button
                            onClick={this.onClickFullscreen}
                            title={this.state.fullscreen ? "Sair de ecrã inteiro" : "Ecrã inteiro"}
                            style={{ width: "100%", height: "100%" }}
                        >
                            {this.state.fullscreen ? <i className="fas fa-compress" /> : <i className="fas fa-expand" />}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(Controlos);
